import { useMediaQuery } from 'react-responsive';

const useDeviceType = () => {
    const isMobile = useMediaQuery({ maxWidth: 425 });
    const isTablet = useMediaQuery({ minWidth: 426, maxWidth: 768 });
    const isLaptop = useMediaQuery({ minWidth: 769, maxWidth: 1024 });
    const isSmallDesktop = useMediaQuery({ minWidth: 1025, maxWidth: 1320 });
    const isDesktop = useMediaQuery({ minWidth: 1321, maxWidth: 1599 });
    const isLargeDesktop = useMediaQuery({ minWidth: 1600 });

    const isLessThan = {
        tablet: useMediaQuery({ maxWidth: 425 }),    
        laptop: useMediaQuery({ maxWidth: 768 }),    
        smallDesktop: useMediaQuery({ maxWidth: 1024 }),
        desktop: useMediaQuery({ maxWidth: 1320 }),
        largeDesktop: useMediaQuery({ maxWidth: 1599 }), 
    };

    const isGreaterThan = {
        mobile: useMediaQuery({ minWidth: 426 }),
        tablet: useMediaQuery({ minWidth: 769 }), 
        laptop: useMediaQuery({ minWidth: 1025 }),  
        smallDesktop: useMediaQuery({ minWidth: 1321 }), 
        desktop: useMediaQuery({ minWidth: 1600 }), 
    };

    const isTabletOrMobile = isLessThan.laptop;
    const isDesktopOrLarger = isGreaterThan.smallDesktop
    return {
        // Точные устройства
        isMobile,
        isTablet,
        isLaptop,
        isSmallDesktop,
        isDesktop,
        isLargeDesktop,

        // Меньше/больше
        isLessThan,
        isGreaterThan,

        // Комбинированные
        isTabletOrMobile,
        isDesktopOrLarger,
    };
};

export default useDeviceType;